module.exports = __webpack_public_path__ + "static/media/icon3.c96722be.jpg";